import { render, staticRenderFns } from "./ResearchRegionDotsTrack.vue?vue&type=template&id=7429dc3a&"
import script from "./ResearchRegionDotsTrack.vue?vue&type=script&lang=js&"
export * from "./ResearchRegionDotsTrack.vue?vue&type=script&lang=js&"
import style0 from "./ResearchRegionDotsTrack.vue?vue&type=style&index=0&id=7429dc3a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7429dc3a')) {
      api.createRecord('7429dc3a', component.options)
    } else {
      api.reload('7429dc3a', component.options)
    }
    module.hot.accept("./ResearchRegionDotsTrack.vue?vue&type=template&id=7429dc3a&", function () {
      api.rerender('7429dc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchRegionDotsTrack.vue"
export default component.exports